import React from "react";
import { motion } from "framer-motion";
import { slideLeft, fadeUp } from "../../animations/variants";

import {
  CheckCircle,
  Leaf,
  UserCheck,
  Globe,
  Activity,
  Clock,
  GraduationCap,
  Briefcase,
  Baby,
  MapPin,
} from "lucide-react";

import { useSelector } from "react-redux";
import { aboutText } from "../../i18n/about";

const About = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = aboutText[lang];

  return (
    <section id="about" className="py-24 px-6 bg-darkbg overflow-hidden">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* TEXT */}
        <div className="order-1 md:order-2">
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            className="text-2xl md:text-3xl font-heading mb-3 text-neonYellow animate-neonFlicker"
          >
            {t.section}
          </motion.h2>

          <motion.h3
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            className="text-4xl md:text-5xl font-heading font-bold text-neonYellow"
          >
            {t.title}
          </motion.h3>

          <motion.div
            variants={fadeUp}
            transition={{ delay: 0.2 }}
            className="mt-6 text-text leading-relaxed text-lg space-y-6"
          >
            {/* NOT JUST */}
            <div>
              <p className="font-semibold">{t.notJustTitle}</p>
              <div className="mt-2 space-y-2">
                {t.notJust.map((item, i) => (
                  <div key={i} className="flex items-start gap-2">
                    <CheckCircle className="w-5 h-5 text-yellow mt-1" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* ALIGNING */}
            <div>
              <p className="font-semibold">{t.aligningTitle}</p>
              <div className="mt-2 space-y-2">
                <div className="flex items-start gap-2">
                  <Leaf className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.aligning[0]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <UserCheck className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.aligning[1]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Activity className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.aligning[2]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Globe className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.aligning[3]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Activity className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.aligning[4]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Clock className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.aligning[5]}</span>
                </div>
              </div>
            </div>

            {/* PERSPECTIVE */}
            <div>
              <p className="font-semibold">{t.perspectiveTitle}</p>
              <div className="mt-2 space-y-2">
                <div className="flex items-start gap-2">
                  <GraduationCap className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.perspective[0]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Briefcase className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.perspective[1]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Baby className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.perspective[2]}</span>
                </div>
                <div className="flex items-start gap-2">
                  <MapPin className="w-5 h-5 text-yellow mt-1" />
                  <span>{t.perspective[3]}</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* IMAGE */}
        <motion.div
          className="order-2 md:order-1"
          variants={slideLeft}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <img
            src="/images/tb5.jpg"
            className="rounded-xl shadow-lg w-full grayscale"
            alt="Career Counselor"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default About;

// import React from "react";
// import { motion } from "framer-motion";
// import { slideLeft, fadeUp } from "../../animations/variants";
// import {
//   CheckCircle,
//   Leaf,
//   UserCheck,
//   Users,
//   Globe,
//   Activity,
//   Clock,
//   GraduationCap,
//   Briefcase,
//   Baby,
//   MapPin,
//   Compass,
// } from "lucide-react";

// const About = () => {
//   return (
//     <section id="about" className="py-24 px-6 bg-darkbg overflow-hidden">
//       <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
//         {/* TEXT — first on mobile, second on desktop */}
//         <div className="order-1 md:order-2">
//           <motion.h2
//             variants={fadeUp}
//             className="text-2xl md:text-3xl font-heading leading-tight mb-3 text-neonYellow animate-neonFlicker"
//           >
//             My Approach
//           </motion.h2>

//           <motion.h2
//             variants={fadeUp}
//             className="text-4xl md:text-5xl font-heading leading-tight font-bold text-neonYellow"
//           >
//             Holistic & Culturally-Aware
//           </motion.h2>

//           {/* CONTENT */}
//           <motion.div
//             variants={fadeUp}
//             transition={{ delay: 0.2 }}
//             className="mt-6 text-text leading-relaxed text-lg space-y-6"
//           >
//             {/* NOT JUST ABOUT */}
//             <div>
//               <p className="font-semibold">
//                 I believe that career guidance is not just about:
//               </p>
//               <div className="mt-2 space-y-2">
//                 <div className="flex items-start gap-2">
//                   <CheckCircle className="w-5 h-5 text-yellow mt-1" />
//                   <span>Choosing a job that’s hiring</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <CheckCircle className="w-5 h-5 text-yellow  mt-1" />
//                   <span>Choosing a “hot” industry</span>
//                 </div>
//               </div>
//             </div>

//             {/* ALIGNING */}
//             <div>
//               <p className="font-semibold">It’s about aligning:</p>

//               <div className="mt-2 space-y-2">
//                 <div className="flex items-start gap-2">
//                   <Leaf className="w-5 h-5 text-yellow mt-1" />
//                   <span>Your personality</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <UserCheck className="w-5 h-5 text-yellow mt-1" />
//                   <span>Your values</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <Activity className="w-5 h-5 text-yellow mt-1" />
//                   <span>Your strengths</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <Globe className="w-5 h-5 text-yellow mt-1" />
//                   <span>Your culture and background</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <Activity className="w-5 h-5 text-yellow mt-1" />
//                   <span>Your current health and capacity</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <Clock className="w-5 h-5 text-yellow mt-1" />
//                   <span>Your stage of life</span>
//                 </div>
//               </div>
//             </div>

//             {/* PERSPECTIVE */}
//             <div>
//               <span className="font-semibold">I bring the perspective of:</span>
//               <div className="mt-2 space-y-2">
//                 <div className="flex items-start gap-2">
//                   <GraduationCap className="w-5 h-5 text-yellow mt-1" />
//                   <span>Someone who once chose the wrong major</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <Briefcase className="w-5 h-5 text-yellow mt-1" />
//                   <span>Someone who has worked across different fields</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <Baby className="w-5 h-5 text-yellow mt-1" />
//                   <span>A mother who has experienced career breaks</span>
//                 </div>

//                 <div className="flex items-start gap-2">
//                   <MapPin className="w-5 h-5 text-yellow mt-1" />
//                   <span>
//                     An immigrant who has started over from the beginning
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* IMAGE — second on mobile, first on desktop */}
//         <motion.div
//           className="order-2 md:order-1"
//           variants={slideLeft}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: true }}
//         >
//           <img
//             src="/images/tb5.jpg"
//             className="rounded-xl shadow-lg w-full grayscale"
//             alt="Career Counselor"
//           />
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default About;
